import { Fragment } from 'react'
import {
  Dialog,
  IconButton,
  Grid,
  makeStyles,
  useMediaQuery,
  Slide,
  Fade,
  useTheme,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import TextCollapseSp from '../ui/TextCollapseSp'
import { useTranslation } from 'next-i18next'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
})

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(5)}px ${theme.spacing(3)}px`,
    position: 'relative',
    '& p': {
      margin: 10,
    },
  },
  closeModal: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
  stepIcon: {
    width: 70,
    height: 70,
  },
  topic: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  modalTitle: {
    marginTop: 0,
    ...theme.headerFont,
  }
}))

const TrackingHelpModal = ({ open, onClose }) => {
  const theme = useTheme()
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { t } = useTranslation('tracking')

  const helpData = [
    {
      title: t('status-pending'),
      desc: t('status-detail.pending'),
      icon: '/static/img/tracking/tracking-step-1.png',
    },
    {
      title: t('status-prepare-to-ship'),
      desc: (
        <>
          <p>
            {t('status-detail.prepare-to-ship.meaning')}
          </p>
          <p>
            <b>{t('status-detail.prepare-to-ship.not-thp')}</b>
            <br />
            <b>SCG</b> : {t('status-detail.prepare-to-ship.scg-condition')}
            <br />
            <b>Ninjavan</b> : {t('status-detail.prepare-to-ship.ninjavan-condition')}
            <br />
            <b>Alphafast</b> : {t('status-detail.prepare-to-ship.alphafast-condition')}
          </p>
          <p>
            {t('status-detail.prepare-to-ship.remark')}
          </p>
        </>
      ),
      icon: '/static/img/tracking/tracking-step-2.png',
    },
    {
      title: t('status-shipping'),
      desc: (
        <p>
          {t('status-detail.shipping')}
        </p>
      ),
      icon: '/static/img/tracking/tracking-step-3.png',
    },
    {
      title: t('status-completed'),
      desc: <p>{t('status-detail.completed')}</p>,
      icon: '/static/img/tracking/tracking-step-4.png',
    },
    {
      title: t('status-something-wrong'),
      desc: <p>{t('status-detail.something-wrong')}</p>,
      icon: '/static/img/tracking/tracking-wrong.png',
    },
    {
      title: t('status-cancelled'),
      desc: <p>{t('status-detail.cancelled')}</p>,
      icon: '/static/img/tracking/tracking-cancelled.png',
    }
  ]

  const classes = useStyles()

  const renderTopic = (topicObj) => (
    <Fragment key={topicObj.title}>
      <Grid item xs={1}>
        <img
          src={topicObj.icon}
          alt=""
          className={classes.stepIcon}
        />
      </Grid>
      <Grid item xs={11}>
        <p className={classes.topic}>{topicObj.title}</p>
        <p>{topicObj.desc}</p>
      </Grid>
    </Fragment>
  )

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="modal-help-tracking"
      maxWidth="md"
      scroll="body"
      fullScreen={isMobile}
      TransitionComponent={isTabletOrMobile ? Transition:Fade}
    >
      <div className={classes.modal}>
        <IconButton className={classes.closeModal} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <h1 className={classes.modalTitle}>{t('status-detail.title')}</h1>
        {!isTabletOrMobile ? (
          <Grid container spacing={1} alignItems="flex-start">
            {helpData.map(renderTopic)}
          </Grid>
        ) : (
          <TextCollapseSp data={helpData} />
        )}
      </div>
    </Dialog>
  )
}

export default TrackingHelpModal
